class levels{
    constructor( id, name,value) {
  
    
    this.id = id
    this.name = name
    this.value= value
    }
    static fromJson({ nivelId, nombre,valor }) {
      return new levels(nivelId, nombre,valor);
    }
  }
  export default levels